<div mat-dialog-title style="margin:0px;">
    <span>Sync Preferences Across Classes</span>
</div>

<mat-dialog-content>
    <div *ngIf="syncPreferencesAcrossCourses">
        Unchecking this setting will make the preferences for <b>all classes</b> be independent. From this point
        forward, if you make a preference change in one class and want the change to apply to all classes, you will
        have to manually go to the preference screen for each class and make the change.<br /><br />
        Are you sure you want to turn off syncing?
    </div>
    <div *ngIf="!syncPreferencesAcrossCourses">
        Checking this setting and saving will make the preferences for <b>this class</b> be applied to <b>all
            classes</b>. If instead you want the preferences from a <span style="font-style:italic;">different</span>
        class to be applied to all classes, click Cancel, go to that other class, go to Preferences, click the
        <span style="font-style:italic;">Sync preferences</span> checkbox, then click Save.<br /><br />
        Are you sure you want to turn on syncing from this class?
    </div>
</mat-dialog-content>

<mat-dialog-actions>
    <div class="flex-footer-right">
        <tyl-button image="Save.png" label="Yes" (clickEvent)="okClick()" style="float:right"></tyl-button>
        <tyl-button image="Cancel.png" label="No" (clickEvent)="closeClick()" style="float:right"></tyl-button>
    </div>
</mat-dialog-actions>